import React from 'react';
import classnames from 'classnames';
import FontAwesome from 'react-fontawesome';

import styles from './select.less';

const EllipsisArrowRenderer = ({ className }) => {
  const _className = classnames(styles['ellipsis-arrow-renderer'], className);

  return <FontAwesome className={_className} name="ellipsis-h" />;
};

EllipsisArrowRenderer.propTypes = {
  ...FontAwesome.propTypes,
};

EllipsisArrowRenderer.defaultProps = {
  ...FontAwesome.defaultProps,
};

export default EllipsisArrowRenderer;
export { EllipsisArrowRenderer };
